import { Element } from '../../../../common/html/element'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { ScoreFormat } from './ScoreFormat'

export const PercentValue = ({ value }) => {
  const { formatCurrencyWithUnit } = useFormatCurrency(SCREEN.SCORE)

  if (!value) return <ScoreFormat current={value} />

  return (
    <>
      <Element
        elementName="p"
        style={{
          fontSize: 14,
          lineHeight: '24px',
          fontWeight: 600,
        }}
      >
        {formatCurrencyWithUnit({ value })}
      </Element>
    </>
  )
}
